const APP_CONFIG = {
  version: "7.92.0",
  title: "Claire V7.92.0",
  version_client: "7.92.0",
};

export default APP_CONFIG;
